import { PlOption } from 'pl-core-services';

export const PL_SERVICE_TYPE_OPTIONS: PlOption[] = [
  { value: 'Therapy', label: 'Therapy' },
  { value: 'Evaluation', label: 'Evaluation' },
  { value: 'Screening', label: 'Screening' },
  { value: 'Consultation', label: 'Consultation' },
];

export const PL_THERAPY_TYPE_OPTIONS: PlOption[] = [
  { value: 'Individual', label: 'Individual' },
  { value: 'Group', label: 'Group' },
];
